import { render, staticRenderFns } from "./huapuGas.vue?vue&type=template&id=0805164e&scoped=true&"
import script from "./huapuGas.vue?vue&type=script&lang=js&"
export * from "./huapuGas.vue?vue&type=script&lang=js&"
import style0 from "./huapuGas.vue?vue&type=style&index=0&id=0805164e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805164e",
  null
  
)

export default component.exports